// bookedBy.js - "Bokad av"-raden för en bokning (Spår K2.2).
// Delas av veckovyn, dagvyn och bokningsrutan.

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

// "30 okt 10:14" (årtal bara om det inte är innevarande år)
const formatBookedAt = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const year = d.getFullYear() !== new Date().getFullYear() ? ` ${d.getFullYear()}` : '';
  const time = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  return `${d.getDate()} ${MONTHS[d.getMonth()]}${year} ${time}`;
};

// "Bokad av Anna Svensson 30 okt 10:14" / "Bokad online 30 okt 10:14".
// null för bokningar utan uppgift (från före K2.2) - då visas ingen rad.
export const bookedByText = (apt) => {
  if (!apt) return null;
  const when = formatBookedAt(apt.booked_at);
  const suffix = when ? ` ${when}` : '';
  if (apt.booked_via === 'online') return `Bokad online${suffix}`;
  if (apt.booked_via === 'import') return `Importerad${suffix}`;
  if (apt.created_by_name) return `Bokad av ${apt.created_by_name}${suffix}`;
  return null;
};
